export const RoleList = [
    {
        prop: "id",
        label: "id",
        width: "150",
        format: "",
        order: false,
        isShow: false
    },
    {
        prop: "code",
        label: "角色编码",
        width: "150",
        format: "",
        order: true,
        isShow: true
    },
    {
        prop: "name",
        label: "角色名称",
        width: "150",
        format: "",
        order: true,
        isShow: true
    },
    {
        prop: "status",
        label: "角色状态",
        width: "150",
        format: "status",
        order: false,
        isShow: true
    },
    {
        prop: "companyId",
        label: "所属公司",
        width: "150",
        format: "",
        order: false,
        isShow: false
    },
    {
        prop: "companyName",
        label: "所属公司",
        width: "150",
        format: "",
        order: false,
        isShow: true
    },
    {
        prop: "remark",
        label: "备注",
        width: "150",
        format: "",
        order: false,
        isShow: true
    },
    {
        prop: "creationTime",
        label: "创建时间",
        width: "150",
        format: "datetime",
        order: true,
        isShow: true
    },
    // {
    //     prop: "creatorId",
    //     label: "创建人",
    //     width: "150",
    //     format: "",
    //     order: false,
    //     isShow: true
    // },
    // {
    //     prop: "lastModificationTime",
    //     label: "修改时间",
    //     width: "150",
    //     format: "datetime",
    //     order: true,
    //     isShow: true
    // },
    // {
    //     prop: "lastModifierId",
    //     label: "修改人",
    //     width: "150",
    //     format: "",
    //     order: false,
    //     isShow: true
    // }
]



